import { useContext } from 'react'
import { EventTrackingContext } from '@website/context/EventTrackingContext'

export const useEventTracking = () => {
  const context = useContext(EventTrackingContext)
  if (context === undefined) {
    throw new Error(
      'useEventTracking must be used within an EventTrackingProvider',
    )
  }
  return context
}
